import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext({ settings: null, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      setSettings((s) => s);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

export const DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=3180+CR+220+STE+6-7,+Middleburg,+FL+32068";

export const MAPS_EMBED =
  "https://www.google.com/maps?q=3180+CR+220,+Middleburg,+FL+32068&output=embed";

export const AREA_DESCRIPTOR = "3180 CR 220 STE 6-7, Middleburg, FL 32068";

export function formatAddress(s) {
  if (!s) return "";
  const cityStateZip = [[s.address_city, s.address_state].filter(Boolean).join(", "), s.address_zip]
    .filter(Boolean).join(" ");
  return [s.address_street, cityStateZip].filter(Boolean).join(", ");
}
